// TRANCHE
import axios from "axios";
import { ERROR, GET_INSURANCE_PREMIUM_PAID_LOANS, GET_REPAYMENT_SCHEDULE, GET_SINGLE_TRANCHE, GET_TRANCHES, GET_USER_ALL_TRANCHES, LOADER, SET_CURRENT_TRANCHE_ID } from "../actionType";
import { toast } from "react-toastify";
import { getAuthToken } from "../../utils/auth";

export const setCurrentTrancheId = (id) => (dispatch) => {
    dispatch({type: SET_CURRENT_TRANCHE_ID, payload: id })
}

export const getAllTranches = (page, limit, status = "", filters = {}) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: LOADER });

        const queryParams = new URLSearchParams({
            page,
            limit
        });

        if(status){
            queryParams.append('status', status);
        }

        const fromDateVal = filters.from_date || filters.start_date || filters.created_from || filters.requested_start_date;
        const toDateVal = filters.to_date || filters.end_date || filters.created_to || filters.requested_end_date;

        if (fromDateVal) {
            queryParams.append('from_date', fromDateVal);
            queryParams.append('start_date', fromDateVal);
            queryParams.append('requested_start_date', fromDateVal);
            queryParams.append('created_from', fromDateVal);
        }
        if (toDateVal) {
            queryParams.append('to_date', toDateVal);
            queryParams.append('end_date', toDateVal);
            queryParams.append('requested_end_date', toDateVal);
            queryParams.append('created_to', toDateVal);
        }

        Object.entries(filters).forEach(([key, value]) => {
            if (['from_date', 'to_date', 'start_date', 'end_date', 'created_from', 'created_to', 'requested_start_date', 'requested_end_date'].includes(key)) {
                return;
            }
            if (typeof value === "boolean") {
                queryParams.append(key, value);
            } else if (value !== "" && value !== null && value !== undefined) {
                queryParams.append(key, value);
            }
        });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/loans/tranche/get-all-tranches?${queryParams.toString()}`, { headers });
        // let response = await axios.get(`http://localhost:8081/api/loans/tranche/get-all-tranches?${queryParams.toString()}`, { headers });
        // console.log("Response ====>", response?.data?.data);

        dispatch({ type: GET_TRANCHES, payload: response?.data?.data })

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
        sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
    }
    catch (err) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all tranches", err);
    }
}

export const getSingleTrancheData = (id) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    dispatch({ type: LOADER })
    await axios.get(`${process.env.REACT_APP_API_BASE_URL}/loans/tranche/get-tranche-details/${id}`, { headers })
    .then(res => {
        dispatch({ type: GET_SINGLE_TRANCHE, payload: res?.data?.data })
    })
    .catch((err) => {
        dispatch({ type: ERROR })
        toast.error(err);
    })
}


export const getRepaymentSchedule = (trancheId) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    dispatch({ type: LOADER })
    await axios.get(`${process.env.REACT_APP_API_BASE_URL}/loans/tranche/get-repayment-schedule/${trancheId}`, { headers })
    .then(res => {
        dispatch({ type: GET_REPAYMENT_SCHEDULE, payload: res?.data?.data })
    })
    .catch((err) => {
        dispatch({ type: ERROR })
        toast.error(err);
    })
}

export const getInsurancePremiumPaidLoans = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    const queryParams = new URLSearchParams({
        page,
        limit
    });

    if(filters?.globalSearch){
        queryParams.append("globalSearch", filters?.globalSearch);
    }

    const headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    };

    try {
        dispatch({ type: LOADER });
        
        // let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/loans/get-insurance-premium-paid-loans?${queryParams.toString()}`, { headers });

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/reports/get-insurance-premium-report?${queryParams.toString()}`, { headers });

        dispatch({ type: GET_INSURANCE_PREMIUM_PAID_LOANS, payload: response?.data?.data });

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
        sessionStorage.setItem('limit', response?.data?.data?.pagination?.limit || 10);
    }   
    catch(err) {
        dispatch({ type: ERROR })
        toast.error(err);
    }
}

export const getAllTranchesForUser = (page, limit, filters) => async (dispatch) => {
    // let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    // let authToken = tokens?.token || null;
    let authToken = getAuthToken();

    if (!authToken) {
        dispatch({ type: ERROR });
        return;
    }

    let headers = {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': 'application/json'
    }

    try {
        dispatch({ type: LOADER });

        const queryParams = new URLSearchParams({
            page,
            limit
        });

        if(filters.status){
            queryParams.append('status', filters.status);
        }

        let response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/loans/tranche/get-loan-tranche/${filters.loan_id}?${queryParams.toString()}`, { headers });
        // console.log("Response ====>", response?.data?.data);

        dispatch({ type: GET_USER_ALL_TRANCHES, payload: response?.data?.data })

        sessionStorage.setItem('totalPages', response?.data?.data?.pagination?.totalPages || 1);
        sessionStorage.setItem('totalCount', response?.data?.data?.pagination?.total || 0);
        sessionStorage.setItem('currentPage', response?.data?.data?.pagination?.page || 1);
        sessionStorage.setItem('applicationTrancheLimit', response?.data?.data?.pagination?.limit || 10);
    }
    catch (err) {
        dispatch({ type: ERROR });
        toast.error("Error in fetching all user tranches", err);
    }
}